import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=02d6039a"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=02d6039a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports